import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import { Box } from '@mui/material'
import { exerciseOptions, fetchData } from '../utils/FetchData'
import Details from '../Components/Details'
function ExerciseDetail() {
  const [exerciseDetail, setExerciseDetail] = useState({})

  const { id } = useParams()
  useEffect(() => {
    const fetchExercisesData = async () => {
      const exerciseBbUrl = 'https://exercisedb.p.rapidapi.com/exercises/exercise';


      const exerciseDeatail = await fetchData(`${exerciseBbUrl}/${id}`, exerciseOptions)
      setExerciseDetail(exerciseDeatail)
      console.log(exerciseDeatail)

    }
    fetchExercisesData()
  }, [])
  return (
    <Box>
      <Details ExerciseDetail={exerciseDetail} />



    </Box>
  )
}

export default ExerciseDetail